export const STRIPE_URL_TYPES = {
    verification: 'verification',
    'billing-info': 'billing-info',
    'new-card': 'new-card',
}
